import React from 'react'
import Logo from "../assets/img/silver/svg/horizontal-logo-disi-cropped.svg"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import '../assets/css/sponsors.css'

const sponsors = [
    { id: 1, image: "https://upload.wikimedia.org/wikipedia/en/thumb/e/eb/Manchester_City_FC_badge.svg/1200px-Manchester_City_FC_badge.svg.png" },
    { id: 2, image: "https://upload.wikimedia.org/wikipedia/tr/4/47/FC_Barcelona.png" },
    { id: 3, image: "https://www.thesportsdb.com/images/media/league/badge/7xjtuy1554397263.png" },
    { id: 4, image: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f5/UEFA_Champions_League.svg/1200px-UEFA_Champions_League.svg.png" },
    { id: 5, image: "https://upload.wikimedia.org/wikipedia/en/thumb/8/84/London_City_Airport_logo.svg/1200px-London_City_Airport_logo.svg.png" },
    { id: 6, image: "https://globalgoodawards.co.uk/wp-content/uploads/2020/01/british-airways-logo.png" },
]

const Footer = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='sponsors-section py-5'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h5 className='mb-4 footer-title text-center' style={{ fontSize: "32px", fontWeight: 600 }}>{t("sponsors")}</h5>
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={30}
                                slidesPerView={1}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                loop={true}
                                breakpoints={{
                                    1024: {
                                        slidesPerView: 5,
                                    }
                                }}
                                className="sponsors-swiper"
                            >
                                {sponsors.map((sponsor) => (
                                    <SwiperSlide key={sponsor.id}>
                                        <div className="sponsor-item">
                                            <img src={sponsor.image} alt={`Sponsor ${sponsor.id}`} className="img-fluid" />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer-content'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-lg-0 mb-4">
                            <div className="w-75">
                                <img src={Logo} alt="logo" width="125px" />
                                <p className="mb-0 mt-4">
                                    {t("footertext")}
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-lg-0 mb-4">
                            <h5 className='mb-4 footer-title'>{t("discover")}</h5>
                            <ul className='p-0 mb-0 list-unstyled footer-navigation-list'>
                                <li>
                                    <Link to="/academy">{t("academy")}</Link>
                                </li>
                                <li>
                                    <Link to="/about">{t("about")}</Link>
                                </li>
                                <li>
                                    <Link to="/trading-platforms">{t("tradingplatforms")}</Link>
                                </li>
                                <li>
                                    <Link to="/faq">{t("faq")}</Link>
                                </li>
                                <li>
                                    <Link to="/investment-products">{t("investmentproducts")}</Link>
                                </li>
                                <li>
                                    <Link to="/account-types">{t("accountTypesTitle")}</Link>
                                </li>
                                <li>
                                    <Link to="/promotions">{t("promotionsTitle")}</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3">
                            <h5 className='mb-4 footer-title'>{t("contact")}</h5>
                            <ul className='p-0 mb-0 list-unstyled footer-navigation-list'>
                                <li>
                                    <span className='fw-bold'>{t("email")}:</span> <a href="mailto:support@silverinvestmentsgroup.com">support@silverinvestmentsgroup.com</a>
                                </li>
                                <li>
                                    <span className='fw-bold'>{t("phone")}:</span>  <a href="https://wa.me/447349861657" target='_blank'>+44 7349 861 657</a>
                                </li>
                                <li>
                                    <span className='fw-bold'>{t("location")}:</span> <a href="https://maps.app.goo.gl/TAB4cXhWHPNtjKUe8" target='_blank'> {t("locationaddress")}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;